var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button',{attrs:{"ghost":"","disabled":_vm.disabled || _vm.downloading,"type":"info","custom-icon":_vm.downloading ? 'fa fa-spinner fa-spin' : 'fa fa-download',"text":"csv"},on:{"on-click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }